import React, { memo } from 'react';
import { createPortal } from 'react-dom';
import type { ExternalToast } from 'sonner';
import { toast, Toaster } from 'sonner';

import { useTheme } from '@doger/ui/theme';

// Toast types
export const $$toast = {
  success: (message: string, options?: ExternalToast) =>
    toast.success(message, options),
  error: (message: string, options?: ExternalToast) =>
    toast.error(message, options),
  warning: (message: string, options?: ExternalToast) =>
    toast.warning(message, options),
  info: (message: string, options?: ExternalToast) =>
    toast.info(message, options),

  dismiss: (id: number | string) => toast.dismiss(id),
};

// Toast container component
export const ToastContainerComponent = memo(() => {
  const { theme } = useTheme();

  return createPortal(
    <Toaster
      position='top-right'
      richColors
      duration={5_000}
      theme={theme}
      closeButton
      style={{ pointerEvents: 'auto' }}
    />,
    document.body
  );
});
